import { CityGuideCardProps } from './CityGuideCard.types';
import './CityGuideCard.scss';
import { Link } from 'react-router-dom';

function CityGuideCard({ header, body, slug }: CityGuideCardProps) {
  return (
    <div className="city-guide-card">
      <div className="city-guide-card-header">{header}</div>
      <div className="city-guide-card-body">{body}</div>
      <div className="city-guide-card-subheader">
        <Link to={`/neighborhood-guide/${slug}`}>NEIGHBORHOOD GUIDE</Link>
      </div>
    </div>
  );
}

export default CityGuideCard;
